import { BreakPoint, listenDevice } from '@adornis/base/client/frontend-helpers/window-size.js';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const isMobileSize: Observable<boolean> = listenDevice.pipe(map(device => device < BreakPoint.tablet));
